import TempNgoService from "./services";
import AccountInfo from "./pages/account-info/store";
import Founders from "./pages/founders-info/store";
import NgoInfo from "./pages/ngo-info/store";
import Documents from "./pages/docs-upload/store";
import Track from "./pages/ministry-track/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  modules: {
    AccountInfo,
    Founders,
    NgoInfo,
    Documents,
    Track
  },
  state: {
    ngoInfo: {},
    accountInfo: {},
    founders: [],
    loading: false,
    docs: {},
    working: false,
    addRequest : false,
    editRequest : false,
  },
  getters: {
    ngoInfo(state) {
      return state.ngoInfo;
    },
    addRequest(state){
      return state.addRequest;
    },
    editRequest(state){
      return state.editRequest;
    },
    foundersValidated(state) {
      for (let index = 0; index < state.founders.length; index++) {
        const element = state.founders[index];
        if (!element.validated) return false;
      }
      return true;
    },
    allValidated(state, getters) {
      return (
        state.ngoInfo.validated &&
        state.accountInfo.validated &&
        getters["foundersValidated"] &&
        getters["Documents/documentsValidated"]
      );
    },
    accountInfo(state) {
      return state.accountInfo;
    },
    founders(state) {
      return state.founders;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
    docs(state) {
      return state.docs;
    },
    events(state) {
      return {
        ngoInfo: state.ngoInfo.history,
        accountInfo: state.accountInfo.history,
        founders: state.founders
          .map((el) => {
            if (el.history.length)
              return { name: el.full_name, history: el.history };
            else return null;
          })
          .filter((el) => el !== null),
      };
    },
  },
  mutations: {
    setNgoInfo(state, payload) {
      state.ngoInfo = payload;
    },
    setAccountInfo(state, payload) {
      state.accountInfo = payload;
    },
    setFounders(state, payload) {
      state.founders = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
    setDocs(state, payload) {
      state.docs = payload;
    },
    setAddRequest(state, payload) {
      state.addRequest = payload;
    },
    setEditRequest(state, payload) {
      state.editRequest = payload;
    },
  },

  actions: {
    async fetchDocs({ commit }, slug) {
      commit("setLoading", true);
      try {
        const data = await TempNgoService.fetchDocs(slug);
        commit("setDocs", data.data[0]);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchNgoData({ commit, dispatch }) {
      commit("setLoading", true);
      try {
        const data = await TempNgoService.fetchNgoData();
        // if(data.data.est_ngo)
          commit("setNgoInfo", data.data.est_ngo);
        // else
        //   commit("setNgoInfo", {'current_stage' : 0});
        commit("setAccountInfo", data.data.est_account);
        commit("User/setUser", data.data.est_account, { root: true });
        commit("setFounders", data.data.est_members);
      } catch (err) {
      } finally {
        commit("setLoading", false);
        dispatch("Documents/fetchDocuments");
      }
    },
    async AddTransactionRequests({ commit, dispatch } , payload) {
      commit("setAddRequest", true);
      try {
        const data = await TempNgoService.AddTransactionRequests(payload);
        // if (hasError(data)) throw data.status;
        if (hasError(data.status)) {
          throw data.status;
        }
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setAddRequest", false);
      }
    },
    async editTransactionRequests({ commit, dispatch } , payload) {
      commit("setAddRequest", true);
      try {
        const data = await TempNgoService.editTransactionRequests(payload);
        // if (hasError(data)) throw data.status;
        if (hasError(data.status)) {
          throw data.status;
        }
        
        return Promise.resolve();
      } catch (err) {
        console.log("err" , err)
        return Promise.reject(err);
      } finally {
        commit("setAddRequest", false);
      }
    },
    
    async changeCurrentStage({ commit, dispatch } , payload) {
      commit("setAddRequest", true);
      try {
        const data = await TempNgoService.changeCurrentStage(payload);
        
        dispatch("fetchNgoData");
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setAddRequest", false);
      }
    },
    
  },
};
